import * as React from "react";
import {
  Menu,
  MenuItem,
  Divider,
  Button,
  Flex,
  MenuButton,
  useAuthenticator,
  Text,
  Loader,
  Image,
} from "@aws-amplify/ui-react";
import logo from "../logos/logo_simple.png"; // Tell webpack this JS file uses this image

import { useAuth } from "../../ui-components/utils";
import { useNavigate } from "react-router-dom";
import { useUserMutation } from "./useUserMutation";
import { useUserQuery } from "./useUserQuery";
import { useProfileQuery } from "../profile/api/useProfileQuery";
import DrawerMenu from "./DrawerMenu";
import SessionContainer from "./SessionContainer";
export default function NavigationHeader() {
  const { mutate: userMutate } = useUserMutation();
  const navigate = useNavigate();
  const { signOut, user } = useAuthenticator((context) => [context.user]);
  const authAttributes = useAuth().user?.attributes ?? {};
  const { data: activeProfile } = useUserQuery();
  const { data: sessionUser, isLoading } = useProfileQuery(user?.userId);
  return (
    <Flex
      grow={1}
      alignItems="center"
      boxShadow="0px 2px 4px rgba(0.05098039284348488, 0.10196078568696976, 0.14901961386203766, 0.05000000074505806)"
      padding="6px 32px 6px 32px"
    >
      <Flex display={{base:"block",large:"none"}}>
        <DrawerMenu />
      </Flex>
      <Flex direction="row">
        <Image
          alt="Logo"
          src={logo}
          objectFit="initial"
          height={{ base: "10vmin" }}
          // width="75%"
        />
        <Button
          size="small"
          variation="link"
          children="About"
          onClick={() => window.open("https://totalcarecompass.com//about")}
        ></Button>
        <Button
          size="small"
          variation="link"
          children="FAQ"
          onClick={() => navigate("/user/kb/faq")}
        ></Button>
      </Flex>
      <Flex justifyContent="flex-end" alignItems="center" grow="1">
        <SessionContainer />
      </Flex>
    </Flex>
  );
}
